import { Injectable, OnInit } from '@angular/core';
import { UtilsService } from './utils.service';

@Injectable({
    providedIn: 'root'
})
export class ConfirmationService {

    YesNoQuestion: any;
    YesNoCancelQuestion: any;

    constructor(private utilsService: UtilsService) {

        var self = this;

        this.YesNoQuestion = function (message, template, data) {
            this.messageText = message;
            this.template = template;
            this.data = data;
            return this;
        }
        this.YesNoCancelQuestion = function (message, template, data) {
            self.YesNoQuestion.call(this, message, template, data);
            return this;
        }
        this.YesNoQuestion.prototype.No = function (action) {
            this.noAction = action;
            return this;
        };
        this.YesNoQuestion.prototype.Yes = function (action) {
            this.yesAction = action;
            return this;
        };
        this.YesNoQuestion.prototype.Ask = function () {

            var modal = self.utilsService.OpenModal(this.messageText, this.template || 'ng1/src/common/yesnoconfirmationmodal.html', 'ModalController', this.data, null, null, true);

            var noAction = this.noAction;
            var yesAction = this.yesAction;

            modal.result.then(function (leave) {
                if (leave === 'no' && noAction) {
                    noAction();
                }

                if (leave === 'yes' && yesAction) {
                    yesAction();
                }

                modal.dismiss();
            });
        };
        this.YesNoCancelQuestion.prototype = Object.create(this.YesNoQuestion.prototype);
        this.YesNoCancelQuestion.prototype.constructor = this.YesNoCancelQuestion;
        this.YesNoCancelQuestion.prototype.Cancel = function (action) {
            this.cancelAction = action;
            return this;
        };
        this.YesNoCancelQuestion.prototype.Ask = function () {
            var modal = self.utilsService.OpenModal(this.messageText, this.template || 'ng1/src/common/confirmationModal.html', 'ModalController', this.data, null, null, true);

            var noAction = this.noAction;
            var yesAction = this.yesAction;
            var cancelAction = this.cancelAction;

            modal.result.then(function (leave) {
                if (leave === 'no' && noAction) {
                    noAction();
                }

                if (leave === 'yes' && yesAction) {
                    yesAction();
                }

                if (!leave && cancelAction) {
                    cancelAction();
                }

                modal.dismiss();
            });
        };
    }


    YesNoConfirmation = (message, template, data) => {
        return new this.YesNoQuestion(message, template, data);
    }

    Confirmation = (message, template, data) => {
        return new this.YesNoCancelQuestion(message, template, data);
    }

    ValidationsChain(configuration) {

        var state = {
            canceled: false
        };

        var currentIndex = 0;

        this.ProcessConfirmationRecord(configuration.confirmations[currentIndex]).then((result) => {

            if (result && !state.canceled) {
                if (currentIndex < configuration.confirmations.length - 1) {
                    this.NextAction(configuration.confirmations, currentIndex + 1, configuration.resultAction, state);
                } else {
                    if (configuration.resultAction) {
                        configuration.resultAction();
                    }
                }
            } else {
                state.canceled = true;
            }
        });
    }

    NextAction(confirmations, index, toPerform, state) {
       this.ProcessConfirmationRecord(confirmations[index]).then((result) => {
            if (result && !state.canceled) {
                if (index < confirmations.length - 1) {
                    this.NextAction(confirmations, index + 1, toPerform, state);
                } else {
                    if (toPerform) {
                        toPerform();
                    }
                }
            } else {
                state.canceled = true;
            }
        });
    }

    ProcessConfirmationRecord(confirmation) {
        var promise = new Promise((resolve, reject) => {
            if (!confirmation.validator.isValid()) {

                var modal = this.utilsService.OpenModal(confirmation.validator.warningMessage(),
                    confirmation.template || confirmation.withCancel ? 'ng1/src/common/confirmationModal.html' : 'ng1/src/common/yesnoconfirmationmodal.html',
                    'ModalController',
                    confirmation.data,
                    null,
                    null,
                    true);

                modal.result.then(function (leave) {
                    resolve(leave === 'yes');
                    modal.dismiss();
                });
            } else {
                resolve(true);
            }
        });

        return promise;
    }

}
